var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/document-upload"
  }, /*#__PURE__*/React.createElement("g", {
    id: "document-upload"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.50001 14.2773V9.27734L5.83334 10.944",
    stroke: "#4D7C79",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.5 9.27734L9.16667 10.944",
    stroke: "#4D7C79",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M18.3333 8.44401V12.6107C18.3333 16.7773 16.6667 18.444 12.5 18.444H7.49999C3.33332 18.444 1.66666 16.7773 1.66666 12.6107V7.61068C1.66666 3.44401 3.33332 1.77734 7.49999 1.77734H11.6667",
    stroke: "#4D7C79",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M18.3333 8.44401H15C12.5 8.44401 11.6667 7.61068 11.6667 5.11068V1.77734L18.3333 8.44401Z",
    stroke: "#4D7C79",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentUpload);
export default __webpack_public_path__ + "static/media/document-upload.2f42ac9d5893f27e6eda307f1081e76e.svg";
export { ForwardRef as ReactComponent };